import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useQuery} from 'react-query'
import {listPrintTemplates} from '../../modules/apps/invoice-management/print-studio/core/_requests'
import {
  printStudioEntryUrl,
  printTemplatesSettingsUrl,
} from '../../modules/apps/invoice-management/print-studio/core/studioUrls'

/**
 * «قالب‌های چاپ» beside «دسترسی سریع»: the selected business's print templates in its settings,
 * and the designer for whoever may edit them. The settings tab and the announcement read the
 * same list under the same key; a failed read only leaves out the details.
 */
export const DashboardPrintTemplates: FC<{companyId: number}> = ({companyId}) => {
  const list = useQuery(
    ['print-templates', companyId],
    ({signal}) => listPrintTemplates(companyId, signal),
    {enabled: companyId > 0, retry: false, refetchOnWindowFocus: false}
  )
  const data = list.data
  const defaultTemplate = data?.templates.find((template) => template.isDefault)
  const editorUrl = data && data.available ? printStudioEntryUrl(data) : null

  return (
    <section className='mp-panel mp-panel--print' aria-labelledby='mp-print-templates-title'>
      <div className='mp-panel__head'>
        <div>
          <span>چاپ صورتحساب</span>
          <h2 id='mp-print-templates-title'>قالب‌های چاپ</h2>
        </div>
        <i className='las la-print' aria-hidden='true' />
      </div>

      <p className='mp-print-card__text'>
        لوگو، مهر و امضا، رنگ برگه و متن ثابت توضیحات را تنظیم کنید و نتیجه را همان لحظه روی
        صورتحساب ببینید.
      </p>

      {data && (
        <p className='mp-print-card__meta'>
          {defaultTemplate ? (
            <>
              قالب پیش‌فرض: <strong>{defaultTemplate.name || defaultTemplate.companyName}</strong>
            </>
          ) : (
            'هنوز قالب چاپی برای این کسب‌وکار ثبت نشده است.'
          )}
        </p>
      )}

      <div className='mp-print-card__actions'>
        <Link className='btn btn-sm btn-light-primary' to={printTemplatesSettingsUrl(companyId)}>
          <i className='las la-th-list' aria-hidden='true' />
          قالب‌های چاپ کسب‌وکار
        </Link>
        {editorUrl && (
          <Link className='btn btn-sm btn-primary' to={editorUrl}>
            <i className='las la-magic' aria-hidden='true' />
            ویرایشگر قالب
          </Link>
        )}
      </div>
    </section>
  )
}
